import React from "react";
import { TFunction } from "i18next";
import { toast, ToastOptions } from "react-toastify";
import { CheckboxIcon } from "@aureskonnect/react-ui";
import { uuid } from "uuidv4";

import { getData } from "@helpers/general";
import { clearMultiCustomSelectionData } from "@components/Common/MultiCustomSelect/store";
import { clearData } from "@components/Common/MultiCustomCreatableSelection/store";

import { store } from "../../../../../redux/store";
import { setIsEdited, setKey } from "../../../../../redux/slices/fidelitySlice";

type Params = {
    data: Record<string, FidelityPayload>;
    userID: number;
    franchiseID: string;
    shopID: string;
    operatorID: string;
    uuidUser: string | null;
    fetchGlobal: FetchGlobal;
    setDesignation: (v: string) => void;
    setChoiceFidelity: (v: string) => void;
    setAuthenticationMode: (v: string[]) => void;
    setIsAddFidelityClicked: (v: boolean) => void;
    t: TFunction;
};

export async function associateFranchiseFidelityToShop(params: Params) {
    const {
        data,
        userID,
        franchiseID,
        shopID,
        operatorID,
        uuidUser,
        fetchGlobal,
        setDesignation,
        setChoiceFidelity,
        setAuthenticationMode,
        setIsAddFidelityClicked,
        t,
    } = params;

    toast.dismiss();

    const body = {
        userId: userID,
        shopId: [shopID],
        franchiseId: franchiseID,
        operatorId: operatorID,
        uuidUser,
        data: { ...data },
        isShop: true,
        add: true,
    };

    const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/fidelity`;

    try {
        const result = (await fetchGlobal(apiUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body),
        })) as { error: boolean };
        if (result.error) throw new Error("error");

        await getData(franchiseID, uuidUser as string, shopID, fetchGlobal);

        toast.success(
            t("The fidelity settings has been successfully assigned"),
            {
                position: toast.POSITION.TOP_CENTER,
                theme: "colored",
                icon: <CheckboxIcon height={25} width={25} fill="white" />,
            } as ToastOptions
        );
        store.dispatch(setKey(uuid()));
        clearMultiCustomSelectionData();
        clearData();
        setDesignation("");
        setChoiceFidelity("");
        setAuthenticationMode([]);
        setIsAddFidelityClicked(false);
        store.dispatch(setIsEdited(false));
    } catch (e) {
        toast.error(t("There's an error"), {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
            theme: "colored",
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        });
    }
}
